import { BrowserRouter } from "react-router-dom";
import BaldaiRoutes from "../../domains/baldai/BaldaiRoutes";
import { LanguageProvider } from "../../domains/baldai/i18n/LanguageContext";
import { ScrollToTop } from "./ScrollToTop";

export default function AppRouter() {
  return (
    <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <LanguageProvider>
        <ScrollToTop />
        <BaldaiRoutes />
      </LanguageProvider>
    </BrowserRouter>
  );
}
